import React, { useLayoutEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useDrag, useDrop } from 'react-dnd';
import PickerTextControls from './pickerTextControls';
import Icon from '../../common/containers/icon';
const dndType = 'PICKER';
const PickerRow = ({
  id,
  index,
  name,
  onOrderChange,
  onTextChange,
  onDisableToggle,
  disabled: _disabled = 0,
  editing,
  onEditingStart
}) => {
  const ref = useRef();
  const [isFirstRender, setIsFirstRender] = useState(true);
  useLayoutEffect(() => {
    setTimeout(() => {
      setIsFirstRender(false);
    }, 500);
  }, []);
  const [{
    handlerId
  }, drop] = useDrop({
    accept: dndType,
    collect(monitor) {
      return {
        handlerId: monitor.getHandlerId()
      };
    },
    // Note (CF): The below code is mostly a modified example from
    // the react-dnd library.
    hover(item, monitor) {
      var _ref$current;
      if (!ref.current) {
        return;
      }
      const dragIndex = item.index;
      const hoverIndex = index;
      // Don't replace items with themselves
      if (dragIndex === hoverIndex) {
        return;
      }
      // Determine rectangle on screen
      const hoverBoundingRect = (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.getBoundingClientRect();
      // Get vertical middle
      const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
      // Determine mouse position
      const clientOffset = monitor.getClientOffset();
      // Get pixels to the top
      const hoverClientY = clientOffset.y - hoverBoundingRect.top;
      // Only perform the move when the mouse has crossed half of the items height
      // When dragging downwards, only move when the cursor is below 50%
      // When dragging upwards, only move when the cursor is above 50%
      // Dragging downwards
      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return;
      }
      // Dragging upwards
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return;
      }
      // Time to actually perform the action
      onOrderChange(dragIndex, hoverIndex);
      /* eslint-disable-next-line no-param-reassign */
      item.index = hoverIndex;
    }
  });
  const drag = useDrag({
    type: dndType,
    item: () => ({
      id,
      index
    }),
    canDrag: () => !editing,
    collect: monitor => ({
      isDragging: monitor.isDragging()
    })
  })[1];
  const [text, setText] = useState(name);
  const handleChange = event => {
    setText(event.target.value);
  };
  const handleSave = () => {
    onTextChange(text);
  };
  drag(drop(ref));
  const isBrandNewElement = isFirstRender && !text;
  return /*#__PURE__*/React.createElement("tr", {
    ref: ref,
    style: {
      animation: isBrandNewElement ? 'shake 0.4s forwards' : ''
    },
    "data-handler-id": handlerId,
    "data-testid": "picker-row"
  }, /*#__PURE__*/React.createElement("td", {
    "aria-label": "picker-row-text",
    colSpan: 2
  }, /*#__PURE__*/React.createElement(Icon, {
    glyph: "bars",
    className: "pr-grab-move"
  }), /*#__PURE__*/React.createElement(PickerTextControls, {
    text: text,
    autoFocus: isBrandNewElement,
    showNewChildButton: false,
    isDisabled: _disabled,
    onDisableToggle: onDisableToggle,
    onSave: handleSave,
    onEdit: () => onEditingStart(index),
    onChange: handleChange,
    editing: editing
  })));
};
PickerRow.propTypes = {
  id: PropTypes.string.isRequired,
  disabled: PropTypes.number,
  index: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  onOrderChange: PropTypes.func.isRequired,
  onDisableToggle: PropTypes.func.isRequired,
  onTextChange: PropTypes.func.isRequired,
  editing: PropTypes.bool.isRequired,
  onEditingStart: PropTypes.func.isRequired
};
export default PickerRow;